import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumber } from 'libphonenumber-js';

@Pipe({
  name: 'phoneNumber',
  standalone: true,
  pure: true,
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return formatPhoneNumber(value);
  }
}

export function formatPhoneNumber(value: string | null | undefined) {
  if (!value) {
    return '';
  }

  const phoneNumber = parsePhoneNumber(value, 'US');
  return phoneNumber.format('NATIONAL');
}
